import React, { useEffect, useState } from "react";
import Sidebar from "../../components/admin/Sidebar";
import Navbar from "../../components/admin/Navbar";
import Footer from "../../components/Footer";
import LogoutModal from "../../components/admin/LogoutModal";
import Meta from "../../components/Meta";
// eslint-disable-next-line
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import Loader from "../../components/Loader";
import { Col, Row, FormControl } from "react-bootstrap";
import api from "../../services/api";
import DataTable from "react-data-table-component";


const OperadorTitularScreen = () => {
  const [loading, setLoading] = useState(true);
  const [users, setUsers] = useState([]);
  const [filterText, setFilterText] = useState("");
  const handlerdata = (dt) => {
    return new Date(dt).toLocaleDateString("pt-BR");
  };


  const columns = [
    {
      width: "30%",
      name: "Operador",
      button: true,
      cell: (row) => (
        <div className="text-center">
          {row.operador_id?.nome}
          <br />
          {row.operador_id?.email}
        </div>
      ),
    },
    {
      width: "10%",
      name: "Liberado em:",
      selector: (row) => handlerdata(row.createdAt),
      sortable: true,
    },
    {
      width: "20%",
      name: "CPF Clientela Titular",
      selector: (row) => row.cpf,
      sortable: true,
    },
    {
      width: "10%",
      name: "Status",
      button: true,
      cell: (row) => (
        <div className="text-center">
          {row.status === 1 ? (
            <span className="badge badge-primary">LIBERADO</span>
          ) : row.status === 2 ? (
            <span className="badge badge-danger">NEGADO</span>
          ) : (
            "-"
          )}
        </div>
      ),
    },
    {
      width: "30%",
      name: "Motivo",
      selector: (row) => row.motivo,
      sortable: true,
    },
  ];

 // const data = users;


  const paginationComponentOptions = {
    rowsPerPageText: "Filas por página",
    rangeSeparatorText: "de",
    selectAllRowsItem: true,
    selectAllRowsItemText: "Todos",
  };

  useEffect(() => {
    const pesquisaCard = async () => {


      try {
        const config = { headers: { "Content-Type": "application/json" } };
        const resp = await api.get("/api/operador-titular", config);
        setUsers(resp.data);
      } catch (error) {
        console.error("Erro ao buscar dados:", error);
        toast.error("Erro ao carregar os dados.");
      } finally {
        setLoading(false);
      }



    };
    if (loading) {
      pesquisaCard();
    }
    // eslint-disable-next-line
  }, [loading]);






    // 🔍 Filtrando usuários com base no texto de busca
    const filteredUsers = users.filter((item) => {
      const nome = item.operador_id?.nome?.toLowerCase() || "";
      const email = item.operador_id?.email?.toLowerCase() || "";
      const cpf = item.cpf?.toLowerCase() || "";
      const motivo = item.motivo?.toLowerCase() || "";
  
      return (
        nome.includes(filterText.toLowerCase()) ||
        email.includes(filterText.toLowerCase()) ||
        cpf.includes(filterText.toLowerCase()) ||
        motivo.includes(filterText.toLowerCase())
      );
    });
  


  return (
    <>
      <ToastContainer />
      <Meta />

      <div id="wrapper">
        <Sidebar />

        <div id="content-wrapper" className="d-flex flex-column">
          <div id="content">
            <Navbar />

            {loading ? (
              <Loader />
            ) : (
              <div className="container-fluid">
                <div className="d-sm-flex align-items-center justify-content-between mb-4"></div>

                <Row>
                  <Col md={4} className="mb-3 mt-3">
                    <FormControl
                      type="text"
                      placeholder="Buscar por nome, email, CPF ou motivo"
                      value={filterText}
                      onChange={(e) => setFilterText(e.target.value)}
                    />
                  </Col>
                </Row>

                <DataTable
                  title="Gerenciamento dos Titulares Realizados pelo CRC"
                  columns={columns}
                  data={filteredUsers}
                  pagination
                  paginationComponentOptions={paginationComponentOptions}
                  noDataComponent="Nenhum registro encontrado."
                />
              </div>
            )}
          </div>

          <Footer />
        </div>
      </div>
      <LogoutModal />
    </>
  );
};

export default OperadorTitularScreen;
